import { createContext, useContext, useState } from '@wordpress/element';
import { useActionParam } from '@api/actions/action';
import { converterParaBlocosGutenberg, salvarRascunhoIa } from './auxiliares/editorIntegration';

const IntegracaoContext = createContext({
  setEditorData: () => {},
  carregando: false,
  setCarregando: () => {},
  realizarAnaliseSeo: false,
  setPalavrasChave: () => {},
  setMetadescricao: () => {},
  setRealizarAnaliseSeo: () => {},
  setHtml: () => {},
  publicar: () => {},
  salvarRascunho: () => {},
});

export const IntegracaoProvider = ({ children }) => {
  let ejInstance = { blocks: [] };
  const [realizarAnaliseSeo, setRealizarAnaliseSeo] = useState(false);
  const [editorData, setEditorData] = useState(ejInstance);
  const [palavrasChave, setPalavrasChave] = useState('');
  const [metadescricao, setMetadescricao] = useState('');
  const [html, setHtml] = useState('');
  const [carregando, setCarregando] = useState({
    publicar: false,
    rascunho: false,
  });
  const { mutateAsync } = useActionParam();

  const publicar = () => {
    setCarregando(prev => ({ ...prev, publicar: true }));

    try {
      const gutenbergBlocks = converterParaBlocosGutenberg(editorData);
      if (!gutenbergBlocks || gutenbergBlocks.length === 0) {
        console.error('Nenhum bloco encontrado para publicar.');
        return;
      }

      localStorage.setItem('opti_editor_blocks', JSON.stringify(gutenbergBlocks));
      window.location.href = `${window.location.origin}/wp-admin/post-new.php?post_type=post`;
    } catch (error) {
      console.error('Erro ao enviar artigo IA:', error);
    } finally {
      setCarregando(prev => ({ ...prev, publicar: false }));
    }
  };

  const salvarRascunho = async () => {
    setCarregando(prev => ({ ...prev, rascunho: true }));

    try {
      const salvarAnalise = html && html !== '';
      const editarAnalise = !salvarAnalise && localStorage.getItem('artigo_em_edicao');
      let htmlEdicao = null;
      if (editarAnalise) {
        htmlEdicao = JSON.parse(localStorage.getItem('artigo_em_edicao'))?.html;
      }

      if (salvarAnalise || editarAnalise) {
        await salvarRascunhoIa(
          editorData,
          palavrasChave,
          metadescricao,
          editarAnalise ? htmlEdicao : html,
          mutateAsync
        ).then(res => {
          localStorage.setItem('id_artigo_ia', res?.id);
          setRealizarAnaliseSeo(true);
        });
      }
    } catch (error) {
      console.error('Error save draft opti:', error);
    } finally {
      setCarregando(prev => ({ ...prev, rascunho: false }));
    }
  };

  const value = {
    setEditorData,
    carregando,
    setCarregando,
    realizarAnaliseSeo,
    setPalavrasChave,
    setMetadescricao,
    setRealizarAnaliseSeo,
    setHtml,
    publicar,
    salvarRascunho,
  };

  return <IntegracaoContext.Provider value={value}>{children}</IntegracaoContext.Provider>;
};

export const useIntegracao = () => {
  const context = useContext(IntegracaoContext);
  if (!context) {
    throw new Error('useIntegracao deve ser usado dentro de um IntegracaoProvider');
  }
  return context;
};
